import { motion } from "framer-motion";

const ScrollingTestimonials = () => {
  return (
    <div className="bg-slate-950 py-28">
      <div className="mb-8 px-4">
        <h3 className="text-white text-h2 font-bold font-sans uppercase text-center">
          Ils en <span className="text-[#9BDAF2]">parlent</span>
        </h3>
        <p className="text-center text-white text-p  mt-2 max-w-lg mx-auto">
          Des retours qui font la différence.
        </p>
      </div>
      <div className="p-4 overflow-x-hidden relative">
        <div className="absolute top-0 bottom-0 left-0 w-24 z-10 bg-gradient-to-r from-slate-900 to-transparent" />

        <div className="flex items-center mb-4">
          <TestimonialList list={testimonials.top} duration={125} />
          <TestimonialList list={testimonials.top} duration={125} />
          <TestimonialList list={testimonials.top} duration={125} />
        </div>

        <div className="absolute top-0 bottom-0 right-0 w-24 z-10 bg-gradient-to-l from-slate-900 to-transparent" />
      </div>
    </div>
  );
};

const TestimonialList = ({ list, reverse = false, duration = 50 }) => {
  return (
    <motion.div
      initial={{ translateX: reverse ? "-100%" : "0%" }}
      animate={{ translateX: reverse ? "0%" : "-100%" }}
      transition={{ duration, repeat: Infinity, ease: "linear" }}
      className="flex gap-4 px-2"
    >
      {list.map((t) => {
        return (
          <div
            key={t.id}
            className="shrink-0 w-[500px] grid grid-cols-[7rem,_1fr] rounded-lg overflow-hidden relative h-fit"
          >
            <img
              src={t.img}
              className="w-full h-44 object-cover"
              alt="Auteur du commentaire"
              loading="lazy"
            />
            <div className="bg-slate-900 text-slate-50 p-4">
              <span className="block font-semibold text-lg mb-1">{t.name}</span>
              <span className="block mb-3 text-sm font-medium">{t.title}</span>
              <span className="block text-sm text-slate-300">{t.info}</span>
            </div>

            <span className="text-7xl absolute top-2 right-2 text-slate-700">
              "
            </span>
          </div>
        );
      })}
    </motion.div>
  );
};

const testimonials = {
  top: [
    {
      id: 1,
      img: "/img/Nikolas.webp",
      name: "Nikolas P.",
      title: "",
      info: "Je ne peux que recommander Baptiste qui a toujours réussi à me motiver, me poussant à me dépasser jusqu’à parfois me surprendre moi-même ! Testé, approuvé et recommandé ✅",
    },
    {
      id: 2,
      img: "/img/Flavie.webp",
      name: "Flavie GP.",
      info: "Coach sportif : alliant sympathie,psychologie,et professionnalisme. Bientôt 1 an que je fais appel aux services de Baptiste,et des résultats visibles.",
    },
    {
      id: 3,
      img: "/img/Jeanne.webp",
      name: "Jeanne BN.",
      info: " Après seulement deux mois, je commence déjà à voir des résultats sans frustration ! Il arrive à motiver sans jugement et prodigue des cours de qualité.",
    },
    {
      id: 4,
      img: "/img/Jason.webp",
      name: "Jason L.",
      info: "Excellent coach, toujours motivant qui donne vraiment envie de s'investir.",
    },
    {
      id: 5,
      img: "/img/Lolo.webp",
      name: "Lolo C.",
      info: "Aujourd’hui Séances de 30 min. Abdo avec bapt : au top le coach ! 👍",
    },
    {
      id: 6,
      img: "/img/Cédric.webp",
      name: "Cédric D.",
      info: "Un collègue coach que j’admire , un puits de connaissance en nutrition et sport. Le meilleur 💪🏼",
    },
  ],
};

export default ScrollingTestimonials;
